module.exports = __webpack_public_path__ + "img/api-money.dc24ee84.png";